module.exports = __webpack_public_path__ + "img/Incidenceresponse.0c9c90f5.jpg";